export const iconFontAwesomeShapesClover = (
	<i className="fa-solid fa-clover"></i>
);
